import { createBlueprint as t } from "@made-people/blueprint";
const l = t({
  slots: {
    base: "text-body-xs lg:text-body-sm leading-normal",
    // Tag Slots
    ul: "list-[disc] pl-8",
    ol: "list-[decimal-leading-zero] pl-8",
    li: "",
    span: "",
    p: "",
    h1: "",
    h2: "",
    h3: "",
    h4: "",
    h5: "",
    h6: "",
    blockquote: "",
    hr: "",
    a: "",
    strong: "",
    em: "",
    code: "",
    img: "",
    table: "",
    thead: "",
    tbody: "",
    tr: "",
    th: "",
    td: "",
    pre: ""
  },
  variants: {}
});
export {
  l as markdownBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
